import { useFormFactory } from '@meilleurtaux/form-factory'
import { ProgressBar, StepperContainer } from '@meilleurtaux/form-factory-ds'
import { memo } from 'react'
import type { Step } from '@meilleurtaux/form-factory'

type StepperProps = {
  closeNavigation?: () => void
  stepper: Step[]
  /** 'progressbar' : barre continue (desktop, position haut) ; 'stepper' : étapes (défaut) */
  variant?: 'progressbar' | 'stepper'
}

const Stepper = memo(
  ({ closeNavigation, stepper, variant = 'stepper' }: StepperProps) => {
    const { goTo, progress } = useFormFactory(import.meta.env.VITE_API_URL)

    if (variant === 'progressbar') return <ProgressBar value={progress.percent} />

    const handleClickEvent = (step: Step) => {
      if (step.state !== 'validated' && step.state !== 'paused') return () => {}
      return () => {
        if (closeNavigation) closeNavigation()
        goTo(step)
      }
    }

    return (
      <StepperContainer
        progress={progress.percent}
        stepperItems={stepper.map((step) => ({
          ...step,
          completion: progress.steps.find((x) => x.position === step.position)?.percent,
        }))}
        handleClickEvent={(step) => handleClickEvent(step)()}
      />
    )
  },
  (prevProps, nextProps) => JSON.stringify(prevProps.stepper) === JSON.stringify(nextProps.stepper),
)

Stepper.displayName = 'Stepper'

export default Stepper
